export function elementFromString(markup) {
  return new DOMParser().parseFromString(markup, 'text/html').body.firstChild
}

export function isElementVisible(el) {
  const visibilityHidden = window.getComputedStyle(el).visibility === 'hidden'
  const displayNone = !(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
  return !visibilityHidden && !displayNone
}
